__turbopack_context__.v({
  "bordered": "STTextarea-module__pM_FkG__bordered",
  "dark": "STTextarea-module__pM_FkG__dark",
  "disabled": "STTextarea-module__pM_FkG__disabled",
  "error": "STTextarea-module__pM_FkG__error",
  "errorText": "STTextarea-module__pM_FkG__errorText",
  "field": "STTextarea-module__pM_FkG__field",
  "label": "STTextarea-module__pM_FkG__label",
  "light": "STTextarea-module__pM_FkG__light",
  "textarea": "STTextarea-module__pM_FkG__textarea",
  "wrapper": "STTextarea-module__pM_FkG__wrapper",
});
